<template>
    <div id="mainViewApp" style="height: 100%; position: relative; overflow: hidden;">
        <div id="splitter" class="viewers-container" :class="{ 'empty-model': isEmptyModel }">
            <div class="left-info-container" v-if="dataFetched && showLeftButtons" @mouseenter="mouseInMenu = true" @mouseleave="mouseInMenu = false">
                <div id="left-menu" class="left-menu">
                    <GifComponent 
                        @gifclicked="showPanel(0)" 
                        :title="'Search'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 0" 
                        :gif_url="'globe-earth.gif'" 
                        :icon_url="'globe-earth.png'"
                        :selected_icon_url="'globe-earth_selected.png'" 
                        :gif_size="'32px'"
                        :png_size="'32px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(1)" 
                        :title="'Bookmark'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 1" 
                        :gif_url="'navegation.gif'" 
                        :icon_url="'navegation.png'"
                        :selected_icon_url="'navegation_selected.png'" 
                        :gif_size="'32px'"
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(2)" 
                        :title="'2D'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 2" 
                        :gif_url="'map.gif'" 
                        :icon_url="'map.png'"
                        :selected_icon_url="'map_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(3)" 
                        :title="'View'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 3" 
                        :gif_url="'3d-cube.gif'" 
                        :icon_url="'3d-cube.png'"
                        :selected_icon_url="'3d-cube_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(4)" 
                        :title="'Tags'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 4" 
                        :gif_url="'locations.gif'" 
                        :icon_url="'locations.png'"
                        :selected_icon_url="'locations_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <!-- <GifComponent 
                           @gifclicked="showPanel(6)"
                           :title="'Files'"
                           :title_class="'left-label'"
                           :is_selected="selectedTab==6"
                           :gif_url="'folders.gif'"
                           :icon_url="'folders.png'"
                           :selected_icon_url="'folders_selected.png'"
                           :gif_size="'32px'"
                           :png_size="'25px'"></GifComponent> -->

                    <GifComponent 
                        @gifclicked="showPanel(7)" 
                        :title="'Documents'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 7" 
                        :gif_url="'folders.gif'" 
                        :icon_url="'folders.png'"
                        :selected_icon_url="'folders_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>

                    <!-- <div class="left-btn" @click="showPanel(7)" :style="{'color':selectedTab==7?'var(--primary-color)':'#f2f2f2'}">
                        <div class="left-icon fas fa-copy"></div>
                        <div class="left-label" style="font-size: 7.5px;">Documents</div>
                    </div> -->
                    <GifComponent 
                        @gifclicked="showPanel(8)" 
                        :title="'Models Browser'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 8" 
                        :gif_url="'pyramid.gif'" 
                        :icon_url="'pyramid.png'"
                        :selected_icon_url="'pyramid_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(9)" 
                        :title="'Point Clouds Download'" 
                        :title_class="'left-label'"
                        :gif_url="'download.gif'" 
                        :icon_url="'download.png'" 
                        :selected_icon_url="'download.png'"
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="startLiveReview()" 
                        v-if="false" 
                        :title="'Live Review'"
                        :title_class="'left-label'" 
                        :gif_url="'social-media.gif'" 
                        :icon_url="'social-media.png'"
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="toggleActivityManager()" 
                        v-if="showActivityManagerBtn"
                        :title="'Activity Manager'" 
                        :title_class="'left-label'" 
                        :gif_url="'connect.gif'"
                        :icon_url="'connect.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="toggleDashboard()" 
                        v-if="showActivityManagerBtn" 
                        :title="'Dashboard'"
                        :title_class="'left-label'" 
                        :gif_url="'dashboard.gif'" 
                        :icon_url="'dashboard.png'"
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                    <GifComponent 
                        @gifclicked="showPanel(11)" 
                        v-if="showAMISTab" 
                        :title="'Inspections'"
                        :title_class="'left-label'" 
                        :gif_url="'AMIS-logo.gif'" 
                        :icon_url="'AMIS-logo.png'"
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>

                    <div style="flex-grow:1;"></div>

                    <GifComponent 
                        @gifclicked="toggleLayouts" 
                        :title="'Layouts'" 
                        :title_class="'left-label'"
                        :gif_url="'layout.gif'" 
                        :icon_url="'layout.png'" 
                        :gif_size="'32px'"
                        :png_size="'32px'"></GifComponent>
                    <!-- <GifComponent 
                           @gifclicked="shareDashboard()"
                           :title="'Share View'"
                           :title_class="'left-label'"
                           :gif_url="'share.gif'"
                           :icon_url="'share.png'"
                           :gif_size="'32px'"
                           :png_size="'25px'"></GifComponent> -->
                    <GifComponent 
                        @gifclicked="showPanel(10)" 
                        :title="'Display Settings'" 
                        :title_class="'left-label'"
                        :is_selected="selectedTab == 10" 
                        :gif_url="'scanning.gif'" 
                        :icon_url="'scanning.png'"
                        :selected_icon_url="'scanning_selected.png'" 
                        :gif_size="'32px'" 
                        :png_size="'25px'"></GifComponent>
                </div>
                <div v-show="isTabShown" id="left-panel" :class="['left-panel', isLeftMenuPinned ? 'pinned-panel' : 'not-pinned-panel']">
                    <div class="top-title-bar">
                        <div class="top-title-name">{{ selectedTabName }}</div>
                        <div class="small-right-btn fas fa-thumbtack" @click="isLeftMenuPinned = !isLeftMenuPinned;" v-if="!(showActivityManager && activityManagerViewIndex !== 1)">
                            <div class="slash-btn fas fa-slash" v-if="!isLeftMenuPinned" style="background-color: transparent;pointer-events: none;"></div>
                        </div>
                        <div class="corner-close-btn" @click="closeLeftTab()">X</div>
                    </div>

                    <GlobalSearch v-show="selectedTab == 0"></GlobalSearch>
                    <BookmarksTab v-if="selectedTab == 1"></BookmarksTab>
                    <Plan2dTab v-if="selectedTab == 2"></Plan2dTab>
                    <ViewsTab v-show="selectedTab == 3"></ViewsTab>
                    <TagsTab v-show="selectedTab == 4"></TagsTab>
                    <AttachmentsTab v-show="selectedTab == 7"></AttachmentsTab>
                    <ModelBrowserTab v-if="selectedTab == 8"></ModelBrowserTab>
                    <PointCloudsDownloadTab v-show="selectedTab == 9"></PointCloudsDownloadTab>
                    <DisplaySettingsTab v-show="selectedTab == 10"></DisplaySettingsTab>
                    <InspectionTab v-if="isAMIS" v-show="selectedTab == 11"></InspectionTab>
                    <AmisTab v-else v-show="selectedTab == 11"></AmisTab>

                    <!-- Decrypted -->
                    <!-- <download-sharefile-tab v-show="selectedTab == 6"></download-sharefile-tab>  -->
                </div>
            </div>
            <div class="all-4-viewers-container" id="all-4-viewers-container" :style="{ 'height': allViewersHeight }">
                <VirtualKeyboard></VirtualKeyboard>                
                <div id="left-side-viewers" class="all-2-viewers-container"
                    :class="{ 'compare-right': compareToRight, 'viewers-2-compare-mode': localShowComparasionTool, 'rotate-all-2-viewers-container': isViewersParallelY }"
                    v-show="isView1Visible || isView2Visible">
                    <PageView 
                        id="topleft-viewer" 
                        :name="'top-left'" 
                        v-show="isView1Visible" 
                        :show_close_btn="showCloseBtn"
                        :view_type="view1Type" 
                        @close_viewer="closeViewer($event, 1)" 
                        @change-view="changeView($event, 1)"
                        :class="[compareToRight ? 'compare-right' : '', localShowComparasionTool ? 'view-compare-mode' : '']"
                        :style="{ 'width': viewCompareWidth }">
                    </PageView>
                    <div v-show="isView2Visible" id="separator2"></div>
                    <PageView 
                        id="bottomleft-viewer" 
                        :name="'bottom-left'" 
                        v-show="isView2Visible"
                        :show_close_btn="showCloseBtn" 
                        :view_type="view2Type" 
                        @close_viewer="closeViewer($event, 2)"
                        @change-view="changeView($event, 2)"
                        :class="[compareToRight ? 'compare-right' : '', localShowComparasionTool ? 'view-compare-mode' : '']"
                        :style="{ 'width': viewCompareWidth }">
                    </PageView>
                </div>
                <div v-show="isView3Visible" id="separator"></div>
                <div id="right-side-viewers" class="all-2-viewers-container"
                    :class="{ 'compare-right': compareToRight, 'viewers-2-compare-mode': localShowComparasionTool, 'rotate-all-2-viewers-container': isViewersParallelY }"
                    v-show="isView3Visible || isView4Visible">
                    <PageView 
                        id="topright-viewer" :name="'top-right'" 
                        v-show="isView3Visible"
                        :show_close_btn="showCloseBtn" 
                        :view_type="view3Type" 
                        @close_viewer="closeViewer($event, 3)"
                        @change-view="changeView($event, 3)"
                        :class="[compareToRight ? 'compare-right' : '', localShowComparasionTool ? 'view-compare-mode' : '']"
                        :style="{ 'width': viewCompareWidth }">
                    </PageView>
                    <div v-show="isView4Visible" id="separator3"></div>
                    <PageView 
                        id="bottomright-viewer" 
                        :name="'bottom-right'" 
                        v-show="isView4Visible"
                        :show_close_btn="showCloseBtn" 
                        :view_type="view4Type" 
                        @close_viewer="closeViewer($event, 4)"
                        @change-view="changeView($event, 4)"
                        :class="[compareToRight ? 'compare-right' : '', localShowComparasionTool ? 'view-compare-mode' : '']"
                        :style="{ 'width': viewCompareWidth }">
                    </PageView>
                </div>
                <div v-show="localShowComparasionTool" id="compare-separator" :style="{ 'right': compareToRight ? panoSeparatorLeft : 'auto', 'left': !compareToRight ? panoSeparatorLeft : 'auto' }">
                    <div style="height:100%;display:flex;flex-direction:column;">
                        <div style="height:50%;"></div>
                        <div class="compare-separator-circle fas fa-grip-lines-vertical"
                            :style="{ 'right': compareToRight ? panoSeparatorLeft : 'auto', 'left': !compareToRight ? panoSeparatorLeft : 'auto' }">
                        </div>
                    </div>
                </div>

                <MessagePopup></MessagePopup> 
                <SuccessfulPopup v-if="localSuccessMessage" :message="localSuccessMessage"></SuccessfulPopup>
                <PointCloudsDisplayPopup v-if="showPointCloudDisplayPopup"></PointCloudsDisplayPopup>
                <AddPropertyPopup v-if="localShowAddProperty"></AddPropertyPopup>
                <LinkedTagsPopup v-if="showLinkedTagsPopup"></LinkedTagsPopup>
                <CropLevelsPopup v-if="showCropLevelPopup" @on-close="showCropLevelPopup = false"></CropLevelsPopup>
                <CopiedText></CopiedText>
                <AddDocumentPopup v-if="showAddDocumentPopup"></AddDocumentPopup>
                <TagDynamicGraphPopup v-if="showTagDynamicGraph"></TagDynamicGraphPopup>
                <SelectDashboardPopup v-show="showSelectDashboardPopup" @open_selected_dashboard='toggleSelectedDashboard'></SelectDashboardPopup>
                <UpdateDocumentPopup v-if="showUpdateDocumentPopup"></UpdateDocumentPopup>
                <PointCloudsDownloadInfo></PointCloudsDownloadInfo>
                <EditShareFilePopup @on-save="editShareFileForPointCloudDownload"></EditShareFilePopup>

                <div class="views-options" v-if="showViewsOptions">
                    <div class="view-options-cards">
                        <div class="view-option-icon single-grid" @click="selectViewOption(0)"></div>
                        <div class="view-option-icon double-grid" @click="selectViewOption(1)"></div>
                        <div class="view-option-icon triple-grid" @click="selectViewOption(2)"></div>
                        <div class="view-option-icon quad-grid" @click="selectViewOption(3)"></div>
                    </div>
                </div>
                <div class="activity-views-options" v-if="showActivityViewsOptions">
                    <div class="view-options-cards">
                        <div class="view-option-icon single-grid" @click="selectActivityViewOption(0)"></div>
                        <div class="view-option-icon double-grid" @click="selectActivityViewOption(1)"></div>
                        <div class="view-option-icon horizontal-grid" @click="selectActivityViewOption(2)"></div>
                    </div>
                </div> 
            </div>

            <markups-popup></markups-popup>
            <markups-minimized-popup></markups-minimized-popup>

            <WorkPackProgressDashboard v-if="showWorkPackProgressDashboard"></WorkPackProgressDashboard>
            <SisTestingDashboard v-if="showSisTestingDashboard"></SisTestingDashboard>
            <InspectionsDashboard v-if="showInspectionDashboard"></InspectionsDashboard>
            <div v-if="showRealityVerticalSpace" class="dashboard-space"></div>
            <div v-if="notificationText" class="notification-div">{{ notificationText }}</div>
            <ScreenOverlay shaded></ScreenOverlay>
            <LoadingPopup :show="localShowLoading"></LoadingPopup> 
        </div>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import $ from 'jquery';
import { isParentOrigin } from '@/utils/forgeMessageUtils';
import { ForgeMessage } from '@/utils/forgeMessageUtils'
import { getURLParameterVal, handleAssetInfo } from '@/store/helpers'
import HttpService from '@/utils/httpService';
import { ForgeProject } from '@/scripts/js/forgeModels'
import { 
    fetchAssetModel, 
    fetchAssetBookmarks, 
    fetchAssetCategories, 
    fetchAssetLevels,  
    fetchAssetModels, 
    fetchAssetPointCloudDownloads, 
    fetchAssetPointCloudModels, 
    fetchUserSettings, 
    fetchState,
    fetchAssetProjects,
    fetchAssetInspections, 
    fetchAssetScaffold, 
    fetchAssetAnnotations, 
    fetchAssetNormalEquipment, 
    fetchAssetManualPipelines,
    fetchAssetManualStructural
} from '@/utils/mongoUtils';
import {
    disposeDocViewer,
    dispose2DViewer,
    dispose3DViewer,
    getViewPage3D,
    getViewPage360,
    getViewPage2d,
    disposeForgeViewers,
    drawMeasureLine,
    getMarkupsComponent,
    getStateId,
    showCopiedTextPopup
} from '@/scripts/js/forgeviewer'
import MarkupsPopup from '@/components/markups/markupsPopup.vue'
import MarkupsPopupMinimized from '@/components/markups/markupsPopupMinimized.vue';

export default {
    name: 'MainView',
    components: {
    PageView: () => import('@/components/common/pageView.vue'),
    GifComponent: () => import('@/components/common/gifComponent.vue'),
    VirtualKeyboard: () => import('@/components/virtual-keyboard/virtual-keyboard.vue'),
    LoadingPopup: () => import('@/components/common/loadingPopup.vue'),
    GlobalSearch: () => import('@/components/search/globalSearch.vue'),
    BookmarksTab: () => import('@/components/bookmarks/dashboardTab.vue'),
    MessagePopup: () => import('@/components/common/messagePopup.vue'),
    Plan2dTab: () => import('@/components/plans2d/plan2dTab.vue'),
    ViewsTab: () => import('@/components/views/viewsTab.vue'),
    TagsTab: () => import('@/components/tags/tagsTab.vue'),
    ScreenOverlay: () => import('@/components/common/screenOverlay.vue'),
    AttachmentsTab: () => import('@/components/attachments/attachmentsTab.vue'),
    ModelBrowserTab: () => import('@/components/modelBrowser/modelBrowserTab.vue'),
    PointCloudsDownloadTab: () => import('@/components/pointcloudDownload/pointCloudsDownloadTab.vue'),
    DisplaySettingsTab: () => import('@/components/settings/displaySettings.vue'),
    AmisTab: () => import('@/components/tags/amisTab.vue'),
    InspectionTab: () => import('@/components/tags/inspections/inspections-tab/inspections-tab.vue'),
    SuccessfulPopup: () => import('@/components/common/successfulPopup.vue'),
    PointCloudsDisplayPopup: () => import('@/components/settings/pointCloudsDisplayPopup.vue'),
    AddPropertyPopup: () => import('@/components/modelBrowser/addPropertyPopup.vue'),
    LinkedTagsPopup: () => import('@/components/tags/linkedTagsPopup.vue'),
    CropLevelsPopup: () => import('@/components/common/cropLevelsPopup.vue'),
    CopiedText: () => import('@/components/common/copiedText.vue'),
    AddDocumentPopup: () => import('@/components/attachments/add-document-popup.vue'),
    TagDynamicGraphPopup: () => import('@/components/common/tag-dynamic-graph.vue'),
    SelectDashboardPopup: () => import('@/components/common/selectDashboardPopup.vue'),
    UpdateDocumentPopup: () => import('@/components/attachments/update-document-popup.vue'),
    PointCloudsDownloadInfo: () => import('@/components/pointcloudDownload/pointCloudsDownloadInfo.vue'),
    EditShareFilePopup: () => import('@/components/shareFile/popups/shareFileEditPopup.vue'),
    InspectionsDashboard: () => import('@/components/dashboard/inspection-dashboard/inspections-dashboard.vue'),
    SisTestingDashboard: () => import('@/components/dashboard/sis-testing-dashboard.vue'),
    WorkPackProgressDashboard: () => import('@/components/workPackProgressDashboard/work-pack-progress-dashboard.vue'),
    'markups-popup': MarkupsPopup,
    'markups-minimized-popup': MarkupsPopupMinimized,
},
    data() {
        return {
            notificationText: '',
            mouseInMenu: false,
            //comparasion
            // showComparasionTool: false,
            panoSeparatorLeft: '50%',
            // viewCompareWidth: 'auto',
            compareToRight: false,
            beforeCompareState: [],
            //for changing for activity manager
            showBackBtn: false,
            showConnectIcons: false,
            showViewsOptions: false,
            showActivityViewsOptions: false,
        };
    },
    mounted() {
        ForgeMessage.sendMessageToParent('toggle-activity-manager', { showActivityManager: false, fullWidth: false });
        ForgeMessage.sendMessageToParent('get-tags-activities', { assetId: this.$store.state.assetId });
        if (window.location.href.includes('invited=true&doNotRedirect=true'))
            this.view1Type = '3d';
        else if (window.location.href.includes('stateId=')) {
            //To be handled automatically
        }
        else
            this.view1Type = '2d';
        if (this.$store.state.defaultViewType || this.$store.state.defaultViewType == '3d')
            this.view1Type = '3d';
        this.$store.state.mainApp = this;
        fetchUserSettings(this.$store.state.userId);
        this.init();
    },
    updated() {
        this.resizeViewers();
    },
    watch: {
        selectedTab: function (value) {
            this.$store.commit("setIsTabShown", true);
        },
        isTabShown: function (value) {
            this.ensureRealityActivityManagerVisWidth();
        }
    },
    methods: {
        editShareFileForPointCloudDownload(id) {
            this.$store.state.editingPointCloudDownloadInfo.downloadUrl = id;
            HttpService.post({
                url: 'api/pointClouds/editPointCloudDownload',
                data: this.$store.state.editingPointCloudDownloadInfo,
            }).then(() => {
                this.$store.dispatch({ type: 'showSuccessfulMessage', message: "Email sent to the user.", timeout: 2000 });
            }).catch((error) => {
                console.log(error);
            });
        },
        toggleDashboard() {
            if (this.showRealityDashboard || this.showInspectionDashboard || this.showSisTestingDashboard || this.showWorkPackProgressDashboard) {
                this.toggleSelectedDashboard();
            }
            else {
                this.$store.commit('SET_SHOW_SELECT_DASHBOARD_POPUP', true);
            }
        },
        toggleSelectedDashboard(selectedDashboard) {

            this.showInspectionDashboard = selectedDashboard === 'New Inspection Dashboard';
            this.showSisTestingDashboard = selectedDashboard === 'Activity Tracker';
            this.showWorkPackProgressDashboard = selectedDashboard === 'Work Pack Tag Progress';

            let showDashboardAM = !this.showInspectionDashboard && !this.showSisTestingDashboard && !this.showWorkPackProgressDashboard && !this.showRealityDashboard && selectedDashboard
            
            this.$store.commit('setIsRealityActivityManagerShown', false);
            
            this.ensureRealityActivityManagerVisWidth();

            this.$store.commit('setIsRealityDashoardShown', showDashboardAM);

            ForgeMessage.sendMessageToParent('toggle-dashboard', { showDashboard: this.showRealityDashboard, selectedDashboard: selectedDashboard });
            ForgeMessage.sendMessageToParent('toggle-activity-manager', { showActivityManager: false, fullWidth: false });

            this.$store.commit('hideThumbnailPopup', '2d');
            this.$store.commit('hideThumbnailPopup', '3d');
            this.$store.commit('hideThumbnailPopup', '360');

        },
        toggleActivityManager() {
            if (this.showActivityManager) {
                this.$store.commit('setIsRealityActivityManagerShown', false);
                this.ensureRealityActivityManagerVisWidth();
                setTimeout(() => {
                    this.resizeViewers();
                }, 50);
            }
            else {
                this.showActivityViewsOptions = !this.showActivityViewsOptions;
            }
        },
        ensureRealityActivityManagerVisWidth() {
            if (this.showActivityManager && this.activityManagerViewIndex !== 1)
                this.isLeftMenuPinned = true;
            ForgeMessage.sendMessageToParent('toggle-activity-manager', {
                showActivityManager: this.showActivityManager,
                viewIndex: this.activityManagerViewIndex,
                fullWidth: !this.isTabShown
            });
        },
        openViewPageWithType(type) {
            if ((this.isView1Visible && this.view1Type == type) ||
                (this.isView2Visible && this.view2Type == type) ||
                (this.isView3Visible && this.view3Type == type) ||
                (this.isView4Visible && this.view4Type == type)) {
                return 0;
            }
            if (!this.view1Type && this.view1Type != type) {
                this.isView1Visible = true;
                this.view1Type = type;
                return 1;
            }
            else if (!this.view3Type && this.view3Type != type) {
                this.isView3Visible = true;
                this.view3Type = type;
                return 3;
            }
            else if (!this.view4Type && this.view4Type != type) {
                this.isView4Visible = true;
                this.view4Type = type;
                return 4;
            }
            else if (!this.view2Type && this.view2Type != type) {
                this.isView2Visible = true;
                this.view2Type = type;
                return 2;
            }
            else {
                this.$store.dispatch('alert_Forge', { message: 'All viewers are in use, please close any of them and try again.' });
            }
        },
        showViewPageWithType(type) {
            if (!this.isView1Visible && this.view1Type == type) {
                this.isView1Visible = true;
            }
            else if (!this.isView2Visible && this.view2Type == type) {
                this.isView2Visible = true;
            }
            else if (!this.isView3Visible && this.view3Type == type) {
                this.isView3Visible = true;
            }
            else if (!this.isView4Visible && this.view4Type == type) {
                this.isView4Visible = true;
            }
        },
        hideViewPageWithType(type) {
            if (this.isView1Visible && this.view1Type == type) {
                this.isView1Visible = false;
            }
            else if (this.isView2Visible && this.view2Type == type) {
                this.isView2Visible = false;
            }
            else if (this.isView3Visible && this.view3Type == type) {
                this.isView3Visible = false;
            }
            else if (this.isView4Visible && this.view4Type == type) {
                this.isView4Visible = false;
            }
        },
        changeView(newType, index) {
            var existingType = this[`view${index}Type`];
            if (existingType == newType)
                return;
            if (existingType == '3d' || newType == '3d')
                dispose3DViewer();
            if (existingType == '2d' || newType == '2d')
                dispose2DViewer();
            if (existingType == 'doc' || newType == 'doc')
                disposeDocViewer();
            if ((existingType == '360' || newType == '360') && this.forgeService.panoramaViewer) {
                this.forgeService.panoramaViewer.destroy();
                this.forgeService.panoramaViewer = null;
                this.$store.state.selectedImage = null;
            }
            if (this.view1Type == newType)
                this.view1Type = '';
            if (this.view2Type == newType)
                this.view2Type = '';
            if (this.view3Type == newType)
                this.view3Type = '';
            if (this.view4Type == newType)
                this.view4Type = '';
            this[`view${index}Type`] = newType;
            this.$store.commit("setIsTabShown", false);
        },
        startLiveReview() {
            if (!getViewPage3D()) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please open 3d view first.'
                });
                return;
            }
            $('#toolbar-collaborateTool').click();
            //change the base URL to the parent URL
            var ext = this.viewer.getExtension('Autodesk.Viewing.Collaboration');

            if (!ext) return;

            if (ext.isActive()) {
                this.collabIntervalId = setInterval(function () {
                    var input = $('#collabBox .collabBoxInputText');
                    if (input.length > 0 && input[0].value.includes(window.location.href)) {
                        clearInterval(this.collabIntervalId);
                        var existingSite = input[0].value;
                        var forgeParams = existingSite.replace(window.location.href, '');
                        var newURL = `${this.$store.state.parentSiteUrl}?assetId=${this.$store.state.assetId}&${forgeParams}`;
                        input[0].value = newURL;
                        input[0].select();
                    }
                }, 1000);
            }
            else {
                clearInterval(this.collabIntervalId);
            }
        },
        resizeViewers() {
            if (this.viewer)
                this.viewer.resize();
            if (this.forgeService && this.forgeService.panoramaViewer) {
                this.forgeService.panoramaViewer.resize();
                let canvas = document.getElementById('pano-canvas');
                if (canvas) {
                    canvas.remove();
                    let viewer360 = getViewPage360();
                    if (viewer360) {
                        getViewPage360().updatePanoDimensionLine();
                    }
                }
            }
            if (this.$store.state.planViewer)
                this.$store.state.planViewer.resize();
            if (this.$store.state.pdfviewer && this.$store.state.pdfViewerLoaded)
                this.$store.state.pdfviewer.resize();
        },
        showPanel(tabIndex, pinned) {
            if (this.selectedTab == 0) {
                this.forgeService.update3dIconsInAllViews();
            }
            if (tabIndex == 1 && !this.viewer) {
                this.$store.dispatch("alert_Forge", { message: 'To open "Bookmark" tab, please open 3D viewer first.' });
                return;
            }
            else if (tabIndex == 8 && (!this.viewer || !this.viewer.model || !this.viewer.model.getInstanceTree())) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: '3D Model is not loaded yet.'
                });
                return;
            }
            this.$store.commit("setLastOpenTabIndex", this.selectedTab);
            this.$store.commit("setSelectedTab", tabIndex);
            this.$store.commit("setIsTabShown", true);
            if (tabIndex == 0 || this.$store.state.lastOpenTabIndex == 0) {
                this.forgeService.update3dIconsInAllViews();
            }
            if (pinned || (('ontouchstart' in window || !!navigator.maxTouchPoints) && !this.$store.state.userSettings.displaySettings.hideKeyboard))
                this.isLeftMenuPinned = true;
            setTimeout(() => {
                this.resizeViewers();
            }, 100);
        },
        init() {
            this.$store.commit("setShowLoading", true);
            disposeForgeViewers();
            this.$store.state.pinnedPoint3d = null;
            this.$store.state.pinnedPoint2d = null;
            this.$store.state.pinnedPoint360 = null;
            let assetId = this.$store.state.assetId;
            this.$store.state.dataFetched = false;
            this.$store.state.mainUrn = null;
            this.$store.state.planUrn = null;
            this.$store.state.selectedLevel = null;
            this.$store.state.selectedImage = null;
            var stateId = getURLParameterVal('stateId');

            this.$store.dispatch('fetchAllAutomaticTagsDbids', { assetId: assetId });
            this.$store.dispatch('FETCH_ALL_PIPELINES_TAGS_INFO', { assetId: assetId });
            this.$store.dispatch('FETCH_ALL_STRUCTURAL_TAGS_INFO', { assetId: assetId });

            if (stateId) {
                this.restoreState(stateId);
            }
            else {
                this.fetchAndApplyProject(assetId, () => {
                    //need to wait a little bit for Forge to unload all its extensions
                    setTimeout(() => {
                        if (getViewPage3D())
                            getViewPage3D().startView();
                    }, 500);
                    setTimeout(() => {
                        if (getViewPage2d())
                            getViewPage2d().startView();
                    }, 500);
                });
                if (this.localShowComparasionTool && getViewPage360())
                    getViewPage360().toggleComparasionTool();
            }
            if (isParentOrigin()) {
                this.$store.state.showLeftButtons = false;
                this.$store.state.showBottomButtons = false;
            }
            // this.dragElement(document.getElementById("separator"), "H");
            // this.dragElement(document.getElementById("separator2"), "V");
            // this.dragElement(document.getElementById("separator3"), "V");
            this.dragElement_CompareTool(document.getElementById("compare-separator"), "H");
            var _this = this;
            window.onclick = function () {
                if (!_this.mouseInMenu && !_this.isLeftMenuPinned && _this.isTabShown)
                    _this.$store.dispatch("closeLeftTab");
            };
        },
        restoreState(stateId) {
            fetchState(stateId, state => {
                if (!state) {
                    this.$store.commit("setShowLoading", false);
                    return;
                }
                this.$store.state.fetchedState = state;
                let assetId = this.$store.state.assetId;
                this.fetchAndApplyProject(assetId, () => {
                    //set selected level first so when viewer2d launch, it opens it directly
                    if (state.viewer2DSettings) {
                        let level = this.$store.state.levels.find(o => o.planUrn == state.viewer2DSettings.urn);
                        this.$store.state.selectedLevel = level;
                    }
                    this.isView1Visible = state.isView1Visible;
                    this.isView2Visible = state.isView2Visible;
                    this.isView3Visible = state.isView3Visible;
                    this.isView4Visible = state.isView4Visible;
                    this.isLeftMenuPinned = state.isLeftMenuPinned;
                    this.$store.commit("setIsTabShown", state.isTabShown);
                    if (state.isTabShown)
                        this.$store.commit("setSelectedTab", state.selectedTab);
                    this.view1Type = state.view1Type;
                    this.view2Type = state.view2Type;
                    this.view3Type = state.view3Type;
                    this.view4Type = state.view4Type;
                    if (state.showActivityManager) {
                        this.$store.commit('setIsRealityActivityManagerShown', state.showActivityManager);
                        this.ensureRealityActivityManagerVisWidth();
                    }
                    document.getElementById('left-side-viewers').style.width = state.leftSideViewersWidth;
                    document.getElementById('right-side-viewers').style.width = state.rightSideViewersWidth;
                    document.getElementById('topleft-viewer').style.height = state.topleftViewerHeight;
                    document.getElementById('bottomleft-viewer').style.height = state.bottomleftViewerHeight;
                    document.getElementById('topright-viewer').style.height = state.topRightViewerHeight;
                    document.getElementById('bottomright-viewer').style.height = state.bottomRightViewerHeight;
                    setTimeout(() => {
                        this.resizeViewers();
                    }, 100);
                    this.$store.commit("setShowComparasionTool", state.showComparasionTool);
                    this.panoSeparatorLeft = state.panoSeparatorLeft;
                    this.viewCompareWidth = state.viewCompareWidth;
                    if (this.localShowComparasionTool && getViewPage360()) {
                        setTimeout(() => {
                            getViewPage360().setPanoWidth(this.panoSeparatorLeft);
                            getViewPage360().containerOpacity = state.container360Opacity;
                            // getViewPage360().showComparasionTool = state.showComparasionTool;
                        }, 100);
                    }
                    //panoViewerSettings
                    if (state.panoViewerSettings) {
                        setTimeout(() => {
                            let project = this.$store.state.projects.find(o => o.images.some(e => e.name == state.panoViewerSettings.image.name));
                            if (project) {
                                let image = project.images.find(o => o.name == state.panoViewerSettings.image.name);
                                image.isLocked = state.isLockedViewer3DAndPano;
                                this.forgeService.launchPanoViewer(image);
                                this.forgeService.panoramaViewer.setYaw(state.panoViewerSettings.yaw);
                                this.forgeService.panoramaViewer.setPitch(state.panoViewerSettings.pitch);
                                this.forgeService.panoramaViewer.setHfov(state.panoViewerSettings.fov);
                                this.forgeService.panoramaViewer.resize();
                                if (state.viewer3DSettings.measuringLineStart && state.viewer3DSettings.measuringLineEnd && getViewPage360()) {
                                    getViewPage360().drawPanoMeasureStartPoint(state.viewer3DSettings.measuringLineStart.pitch, state.viewer3DSettings.measuringLineStart.yaw);
                                    getViewPage360().drawPanoMeasureEndPoint(state.viewer3DSettings.measuringLineEnd.pitch, state.viewer3DSettings.measuringLineEnd.yaw);
                                    getViewPage360().updatePanoDimensionLine();
                                }
                            }
                        }, 100);
                    }
                    //viewer2DSettings
                    if (state.viewer2DSettings) {
                        setTimeout(() => {
                            if (this.$store.state.planViewer) {
                                this.$store.state.planViewer.restoreState(state.viewer2DSettings.viewerState, false, true);
                                let planExtension = this.forgeService.getDrawPointsExtension();
                                if (planExtension && state.viewer2DSettings.measuredArea && state.viewer2DSettings.measuredArea.length > 0) {
                                    planExtension.areaPoints = state.viewer2DSettings.measuredArea;
                                    planExtension.measuringDone = true;
                                    planExtension.updatePolygonGl();
                                }
                                if (state.viewer2DSettings.measuringLine) {
                                    let measure2DEx = this.forgeService.getMeasureExtensionInViewer2D();
                                    drawMeasureLine(state.viewer2DSettings.measuringLine, measure2DEx);
                                }
                            }
                        }, 1500);
                    }
                    //markupsViewerSettings
                    if (state.markupsViewerSettings && state.markupsViewerSettings.urn) {
                        let annotation = this.$state.annotations.find(o => o.id == state.markupsViewerSettings.annotationGuid);
                        if (annotation) {
                            let markup = annotation.markups.find(o => o.urn == state.markupsViewerSettings.urn);
                            if (markup) {
                                getMarkupsComponent().show(annotation, markup, state.markupsViewerSettings.pageId);
                                setTimeout(() => {
                                    getMarkupsComponent().markupViewer.restoreState(state.markupsViewerSettings.viewerState, false, true);
                                }, 2000);
                            }
                        }
                    }
                });
            });
        },
        dragElement_CompareTool(element, direction) {
            let _this = this;
            let md; // remember mouse down info
            element.addEventListener('mousedown', onDragStart);
            element.addEventListener('touchstart', onDragStart);
            function onDragStart(e) {
                const isTouch = e.type === 'touchstart';
                md = {
                    e,
                    offsetLeft: element.offsetLeft,
                    firstWidth: getViewPage360().$el.parentElement.offsetWidth,
                };
                const moveEvent = isTouch ? 'touchmove' : 'mousemove';
                const endEvent = isTouch ? 'touchend' : 'mouseup';
                document.addEventListener(moveEvent, onDragMove);
                document.addEventListener(endEvent, onDragEnd);
            }
            function onDragMove(e) {
                const isTouch = e.type === 'touchmove';
                const clientX = isTouch ? e.changedTouches[0].clientX : e.clientX;
                const clientY = isTouch ? e.changedTouches[0].clientY : e.clientY;
                const mdClientX = isTouch ? md.e.changedTouches[0].clientX : md.e.clientX;
                const mdClientY = isTouch ? md.e.changedTouches[0].clientY : md.e.clientY;
                const delta = {
                    x: clientX - mdClientX,
                    y: clientY - mdClientY,
                };
                if (direction === 'H') {
                    const factor = _this.compareToRight ? -1 : 1;
                    const width = `${md.firstWidth + factor * delta.x}px`;
                    getViewPage360().setPanoWidth(width);
                }
            }
            function onDragEnd() {
                document.removeEventListener('mousemove', onDragMove);
                document.removeEventListener('mouseup', onDragEnd);
                document.removeEventListener('touchmove', onDragMove);
                document.removeEventListener('touchend', onDragEnd);
            }
        },
        dragElement_CompareTool2(element, direction) {
            var _this = this;
            var md; // remember mouse down info
            element.onmousedown = onMouseDown;
            element.ontouchstart = (e) => {
                md = {
                    e,
                    offsetLeft: element.offsetLeft,
                    firstWidth: getViewPage360().$el.parentElement.offsetWidth,
                };
                element.ontouchmove = onTouchMove;
            };
            function onTouchMove(e) {
                var delta = {
                    x: e.changedTouches[0].clientX - md.e.changedTouches[0].clientX,
                    y: e.changedTouches[0].clientY - md.e.changedTouches[0].clientY
                };
                if (direction === "H") // Horizontal
                 {
                    let factor = _this.compareToRight ? -1 : 1;
                    var width = (md.firstWidth + (factor * delta.x)) + "px";
                    getViewPage360().setPanoWidth(width);
                }
            }
            element.ontouchend = (e) => {
                console.log('ontouchend', e);
                element.ontouchmove = null;
            };
            function onMouseDown(e) {
                console.log("onMouseDown", e);
                md = {
                    e,
                    offsetLeft: element.offsetLeft,
                    firstWidth: getViewPage360().$el.parentElement.offsetWidth,
                };
                document.onmousemove = onMouseMove;
                document.onmouseup = () => {
                    document.onmousemove = document.onmouseup = null;
                };
            }
            function onMouseMove(e) {
                console.log("onMouseMove", e);
                var delta = {
                    x: e.clientX - md.e.clientX,
                    y: e.clientY - md.e.clientY
                };
                if (direction === "H") // Horizontal
                 {
                    let factor = _this.compareToRight ? -1 : 1;
                    var width = (md.firstWidth + (factor * delta.x)) + "px";
                    getViewPage360().setPanoWidth(width);
                }
            }
        },
        fetchAndApplyProject(assetId, callback) {
            this.$store.dispatch('REQUEST_DOCUMENT_TYPES');
            fetchAssetModel(assetId).then(asset => {
                fetchAssetModels(assetId, asset.selectedModel).then(models => {
                    this.$store.state.uploadedModels = models;
                });
                fetchAssetLevels(assetId).then(levels => {
                    this.$store.state.selectedLevel = levels.find(o => o.name == asset.selectedLevel);
                    this.$store.state.levels = levels;
                });
                handleAssetInfo(asset);
                this.$store.commit("setShowLoading", false);
                if (callback)
                    callback();
            });
            const normalEquipmentRequest = fetchAssetNormalEquipment(assetId).then(normalEquipment => {
                this.$store.commit('setTags', normalEquipment);
                this.$store.commit("SET_AUTOMATIC_TAGS", []);
            });
            const manualPipelinesRequest = fetchAssetManualPipelines(assetId).then(manualPipelines => {
                this.$store.commit('SET_MANUAL_PIPELINES_TAGS', manualPipelines);
            });
            const manualStructuralRequest = fetchAssetManualStructural(assetId).then(manualStructural => {
                this.$store.commit('SET_MANUAL_STRUCTURAL_TAGS', manualStructural);
            });
            const annotationsRequest = fetchAssetAnnotations(assetId, this.$store.state.userId).then(annotations => {
                this.$store.commit('setAnnotations', annotations);
            });
            const scaffoldsRequest = fetchAssetScaffold(assetId).then(scaffolds => {
                this.$store.commit('setScaffolds', scaffolds);
            });
            const inspectionsRequest = fetchAssetInspections(assetId).then(inspections => {
                this.$store.commit('setInspections', inspections);
                if (inspections?.length)
                    this.$store.dispatch('UPDATE_INSPECTIONS_UNITS');
            });
            Promise.all([normalEquipmentRequest, manualPipelinesRequest, manualStructuralRequest, annotationsRequest, scaffoldsRequest, inspectionsRequest]).then(responses => {
                this.$store.state.dataFetched = true;
                if (this.forgeService.getMainExtension() && this.viewer && this.viewer.model) {
                    this.forgeService.getMainExtension()?.syncTagsToViewer();
                }
                this.forgeService.update3dIconsInAllViews();
                this.forgeService.dbIdPerObj = [];
            });
            fetchAssetBookmarks(assetId).then(cameras => {
                this.$store.state.cameras = cameras;
            });
            fetchAssetPointCloudModels(assetId).then(pointClouds => {
                this.$store.state.pointClouds = pointClouds;
            });
            fetchAssetPointCloudDownloads(assetId).then(pointCloudDownloads => {
                this.$store.state.pointCloudDownloads = pointCloudDownloads;
            });
            fetchAssetCategories(assetId).then(categories => {
                //to keep the reference to apply on the UI correctly
                this.$store.state.categories = [...categories];
            });
            fetchAssetProjects(assetId).then(data => {
                let show360 = this.$store.state.userSettings.displaySettings.show360;
                let projects = ForgeProject.parseProjectsFromDB(data);
                this.$store.state.projects = projects;
                projects.forEach(p => {
                    p.setAllImagesVisibleInViewers(show360);
                });
            });
        },
        dragElement(element, direction) {
            var md; // remember mouse down info
            element.onmousedown = onMouseDown;
            var _this = this;
            function onMouseDown(e) {
                var rightOne = element.nextElementSibling;
                md = {
                    e,
                    offsetLeft: element.offsetLeft,
                    offsetTop: element.offsetTop,
                    firstWidth: element.previousElementSibling.offsetWidth,
                    secondWidth: rightOne.offsetWidth,
                    firstHeight: element.previousElementSibling.offsetHeight,
                    secondHeight: rightOne.offsetHeight
                };
                document.onmousemove = onMouseMove;
                document.onmouseup = () => {
                    //console.log("mouse up");
                    document.onmousemove = document.onmouseup = null;
                };
            }
            function onMouseMove(e) {
                //console.log("mouse move: " + e.clientX);
                var delta = {
                    x: e.clientX - md.e.clientX,
                    y: e.clientY - md.e.clientY
                };
                if (direction === "H") // Horizontal
                 {
                    delta.x = Math.min(Math.max(delta.x, -md.firstWidth), md.secondWidth);
                    var rightOne = element.nextElementSibling;
                    element.style.left = md.offsetLeft + delta.x + "px";
                    element.previousElementSibling.style.width = (md.firstWidth + delta.x) + "px";
                    rightOne.style.width = (md.secondWidth - delta.x) + "px";
                }
                else if (direction == 'V') {
                    delta.y = Math.min(Math.max(delta.y, -md.firstHeight), md.secondHeight);
                    rightOne = element.nextElementSibling;
                    element.style.top = md.offsetTop + delta.y + "px";
                    element.previousElementSibling.style.height = (md.firstHeight + delta.y) + "px";
                    rightOne.style.height = (md.secondHeight - delta.y) + "px";
                }
                setTimeout(() => {
                    _this.resizeViewers();
                }, 100);
            }
        },
        showNotification(text) {
            this.notificationText = text;
            var _this = this;
            setTimeout(() => {
                _this.notificationText = undefined;
            }, 2000);
        },
        shareDashboard() {
            getStateId(id => {
                let url = `${this.$store.state.parentSiteUrl}?assetId=${this.$store.state.assetId}&stateId=${id}`;
                showCopiedTextPopup(url, 'Note: URL will expire in 7 days.');
            });
        },
        selectViewOption(index) {
            if (index == 0) {
                if (this.showenViewersLength != 1) {
                    if (this.isView1Visible) {
                        this.isView2Visible = false;
                        this.isView3Visible = false;
                        this.isView4Visible = false;
                    }
                    else if (this.isView2Visible) {
                        this.isView3Visible = false;
                        this.isView4Visible = false;
                    }
                    else {
                        this.isView4Visible = false;
                    }
                }
                for (let i = 1; i <= 4; i++) {
                    if (!this[`view${i}Type`] && this[`isView${i}Visible`]) {
                        this[`isView${i}Visible`] = false;
                    }
                }
            }
            else if (index == 1) {
                if (this.showenViewersLength != 2) {
                    if (this.showenViewersLength == 1) {
                        let visable = 0;
                        for (let i = 1; i <= 4; i++) {
                            if (this[`isView${i}Visible`]) {
                                visable = i;
                                break;
                            }
                        }
                        if (visable > 2) {
                            this.isView1Visible = true;
                        }
                        else {
                            this.isView3Visible = true;
                        }
                    }
                    else if (this.showenViewersLength == 3) {
                        let temp = 0;
                        for (let i = 1; i <= 4; i++) {
                            if (this[`isView${i}Visible`]) {
                                temp += i;
                            }
                        }
                        if (temp % 2 == 0) {
                            this.isView2Visible = false;
                            this.isView4Visible = false;
                        }
                        else {
                            this.isView1Visible = false;
                            this.isView3Visible = false;
                        }
                    }
                    else {
                        this.isView1Visible = true;
                        this.isView2Visible = false;
                        this.isView3Visible = true;
                        this.isView4Visible = false;
                    }
                }
            }
            else if (index == 2) {
                if (this.showenViewersLength != 3) {
                    if (this.showenViewersLength == 1) {
                        let visable = 0;
                        for (var i = 1; i <= 4; i++) {
                            if (this[`isView${i}Visible`]) {
                                visable = i;
                                break;
                            }
                        }
                        if (visable > 2) {
                            this.isView1Visible = true;
                            this.isView2Visible = true;
                        }
                        else {
                            this.isView3Visible = true;
                            this.isView4Visible = true;
                        }
                    }
                    else if (this.showenViewersLength == 2) {
                        for (let i = 4; i >= 1; i--) {
                            if (!this[`isView${i}Visible`]) {
                                if (i == 2 && !this.isView1Visible) {
                                    this.isView1Visible = true;
                                }
                                else {
                                    this[`isView${i}Visible`] = true;
                                }
                                break;
                            }
                        }
                    }
                    else {
                        this.isView2Visible = false;
                    }
                }
            }
            else if (index == 3) {
                this.isView1Visible = true;
                this.isView2Visible = true;
                this.isView3Visible = true;
                this.isView4Visible = true;
            }
            debugger;
            this.showViewsOptions = false;
            if (this.localShowComparasionTool && getViewPage360())
                getViewPage360().toggleComparasionTool();
            setTimeout(() => {
                this.resizeViewers();
            }, 50);
        },
        selectActivityViewOption(index) {
            this.activityManagerViewIndex = index;
            this.showActivityViewsOptions = false;
            ForgeMessage.sendMessageToParent('toggle-dashboard', { showDashboard: false });
            this.$store.commit('setIsRealityDashoardShown', false);
            this.$store.commit('setIsRealityActivityManagerShown', true);
            this.ensureRealityActivityManagerVisWidth();
            setTimeout(() => {
                this.resizeViewers();
            }, 50);
            this.$store.commit('hideThumbnailPopup', '2d');
            this.$store.commit('hideThumbnailPopup', '3d');
            this.$store.commit('hideThumbnailPopup', '360');
        },
        closeViewer(viewType, viewerIndex) {
            this[`isView${viewerIndex}Visible`] = false;
            this.changeView('', viewerIndex);
        },
        openComparisonsViewers() {
            let indexCount = 0;
            this.beforeCompareState = [];
            let viewer360Index = this.getViewTypeIndex("360");
            let viewer3dIndex = this.getViewTypeIndex("3d");
            for (let i = 1; i <= 4; i++) {
                this.beforeCompareState.push({
                    visibility: this[`isView${i}Visible`],
                    type: this[`view${i}Type`]
                });
                if (this[`view${i}Type`] == "360" || this[`view${i}Type`] == "3d") {
                    indexCount += i;
                }
            }
            if (indexCount == 3 || indexCount == 7) {
                // move 360 viewer in the empty viewer or 2d viewer
                let targetIndex = this.getViewTypeIndex("");
                if (!targetIndex) {
                    targetIndex = this.getViewTypeIndex("2d");
                }
                this.changeView("360", targetIndex);
            }
            for (let i = 1; i <= 4; i++) {
                if ((this[`view${i}Type`] == "360") || (this[`view${i}Type`] == "3d")) {
                    this[`isView${i}Visible`] = true;
                }
                else {
                    this[`isView${i}Visible`] = false;
                }
            }
            this.compareToRight = (viewer360Index > viewer3dIndex && !this.isViewersParallelY) || (viewer360Index < viewer3dIndex && this.isViewersParallelY);
            this.$store.state.mainApp.resizeViewers();
        },
        restoreBeforeCompare() {
            for (let i = 1; i <= 4; i++) {
                this[`isView${i}Visible`] = this.beforeCompareState[i - 1].visibility;
                if (this[`view${i}Type`] != this.beforeCompareState[i - 1].type) {
                    this.changeView(this.beforeCompareState[i - 1].type, i);
                }
            }
        },
        showHiddenPanel(viewer) {
            this[`isView${this.viewer.index}Visible`] = true;
            this.showViewsOptions = false;
            setTimeout(() => {
                this.resizeViewers();
            }, 50);
        },
        getViewTypeIndex(type) {
            for (let i = 1; i <= 4; i++) {
                if (this[`view${i}Type`] == type || (!type && !this[`view${i}Type`])) {
                    return i;
                }
            }
            return 0;
        },
        closeLeftTab() {
            this.$store.dispatch("closeLeftTab");
        },
        toggleLayouts() {
            if (this.localShowComparasionTool) {
                this.$store.dispatch("alert_Forge", { message: `Please stop the compare tool first.` });
                return;
            }
            this.showViewsOptions = !this.showViewsOptions;
        }
    },
    computed: {
        view1Type: {
            get() {
                return this.$store.getters['GET_VIEW_1_TYPE'];
            },
            set(value) {
                this.$store.commit('SET_VIEW_1_TYPE', value);
            }
        },
        view2Type: {
            get() {
                return this.$store.getters['GET_VIEW_2_TYPE'];
            },
            set(value) {
                this.$store.commit('SET_VIEW_2_TYPE', value);
            }
        },
        view3Type: {
            get() {
                return this.$store.getters['GET_VIEW_3_TYPE'];
            },
            set(value) {
                this.$store.commit('SET_VIEW_3_TYPE', value);
            }
        },
        view4Type: {
            get() {
                return this.$store.getters['GET_VIEW_4_TYPE'];
            },
            set(value) {
                this.$store.commit('SET_VIEW_4_TYPE', value);
            }
        },
        isView1Visible: {
            get() {
                return this.$store.getters['GET_IS_VIEW_1_VISIBLE'];
            },
            set(value) {
                this.$store.commit('SET_IS_VIEW_1_VISIBLE', value);
            }
        },
        isView2Visible: {
            get() {
                return this.$store.getters['GET_IS_VIEW_2_VISIBLE'];
            },
            set(value) {
                this.$store.commit('SET_IS_VIEW_2_VISIBLE', value);
            }
        },
        isView3Visible: {
            get() {
                return this.$store.getters['GET_IS_VIEW_3_VISIBLE'];
            },
            set(value) {
                this.$store.commit('SET_IS_VIEW_3_VISIBLE', value);
            }
        },
        isView4Visible: {
            get() {
                return this.$store.getters['GET_IS_VIEW_4_VISIBLE'];
            },
            set(value) {
                this.$store.commit('SET_IS_VIEW_4_VISIBLE', value);
            }
        },
        dataFetched() {
            return this.$store.state.dataFetched;
        },
        selectedTabName: function () {
            if (this.selectedTab == 0)
                return "Search";
            else if (this.selectedTab == 1)
                return "Bookmark";
            else if (this.selectedTab == 2)
                return "2D";
            else if (this.selectedTab == 3)
                return "View";
            else if (this.selectedTab == 4)
                return "Tags";
            else if (this.selectedTab == 6)
                return "Files";
            else if (this.selectedTab == 7)
                return "Documents";
            else if (this.selectedTab == 8)
                return "Model Browser";
            else if (this.selectedTab == 9)
                return "Custom Download";
            else if (this.selectedTab == 10)
                return "Display Settings";
            else if (this.selectedTab == 11)
                return "Inspection";
            return 0;
        },
        isTabShown: function () {
            return this.$store.state.isTabShown;
        },
        viewCompareWidth: function () {
            if (this.isViewersParallelY) {
                return "100%";
            }
            if (!this.localShowComparasionTool)
                return 'auto';
            if (this.isLeftMenuPinned && this.isTabShown)
                return 'calc(100vw - 340px)';
            else
                return 'calc(100vw - 40px)';
        },
        allViewersHeight: function () {
            if (this.showActivityManager && this.activityManagerViewIndex === 2)
                return 'calc(50% - 1px)';
            else
                return '100%';
        },
        showActivityManager() {
            return this.$store.getters['getIsRealityActivityManagerShown'];
        },
        showRealityDashboard() {
            return this.$store.getters['getIsRealityDashoardShown'];
        },
        localSuccessMessage: function () {
            return this.$store.getters['getSuccessMessage'] ?? '';
        },
        localShowAddProperty: function () {
            return this.$store.getters['getShowAddProperty'] ?? false;
        },
        showActivityManagerBtn: function () {
            return this.$store.getters['getShowActivityManagerBtn'];
        },
        showAMISTab: function () {
            return !!this.$store.state.forgeSettings?.isInspectionsOn;
        },
        showCloseBtn: function () {
            let opened = 0;
            if (this.isView1Visible)
                opened++;
            if (this.isView2Visible)
                opened++;
            if (this.isView3Visible)
                opened++;
            if (this.isView4Visible)
                opened++;
            return opened > 1 && !this.localShowComparasionTool;
        },
        localShowComparasionTool: function () {
            return this.$store.getters['getShowComparasionTool'];
        },
        hiddenViewers: function () {
            let hidden = [];
            for (var i = 1; i <= 4; i++) {
                if (!!this[`view${i}Type`] && !this[`isView${i}Visible`]) {
                    hidden.push({
                        index: i,
                        type: this[`view${i}Type`]
                    });
                }
            }
            return hidden;
        },
        showenViewersLength: function () {
            let length = 0;
            for (var i = 1; i <= 4; i++) {
                if (this[`isView${i}Visible`]) {
                    length++;
                }
            }
            return length;
        },
        isViewersParallelY: function () {
            return (this.showenViewersLength == 2 && ((this.isView1Visible && this.isView2Visible) || (this.isView3Visible && this.isView4Visible)));
        },
        localShowLoading() {
            return this.$store.getters['getShowLoading'];
        },
        selectedTab() {
            return this.$store.state.selectedTab;
        },
        showLinkedTagsPopup() {
            return !!this.$store.getters['GET_LINKED_TAGS_CALLBACK'];
        },
        showCropLevelPopup: {
            get() {
                return this.$store.getters['getShowCropLevelPopup'];
            },
            set(value) {
                this.$store.commit('setShowCropLevelPopup', value);
            }
        },
        showPointCloudDisplayPopup: {
            get() {
                return this.$store.state.showPointCloudDisplayPopup;
            }
        },
        showLeftButtons: function () {
            return this.$store.getters['getShowLeftButtons'];
        },
        showAddDocumentPopup: function () {
            return this.$store.getters['GET_SHOW_ADD_DOCUMENT_POPUP'];
        },
        showUpdateDocumentPopup: function () {
            return this.$store.getters['GET_SHOW_UPDATE_DOCUMENT_POPUP'];
        },
        showSelectDashboardPopup: function () {
            return this.$store.getters['GET_SHOW_SELECT_DASHBOARD_POPUP'];
        },
        showTagDynamicGraph: function () {
            return !!this.$store.getters['GET_TAG_DYNAMIC_GRAPH'];
        },
        isEmptyModel: function () {
            return this.$store.getters['GET_IS_EMPTY_MODEL'];
        },
        showRealityVerticalSpace() {
            return this.showRealityDashboard || (this.showActivityManager && this.activityManagerViewIndex === 1);
        },
        compareModeReady: function () {
            let result = 0;
            for (let i = 1; i <= 4; i++) {
                if ((this[`view${i}Type`] == "360") || (this[`view${i}Type`] == "3d")) {
                    result++;
                }
            }
            return result == 2;
        },
        activityManagerViewIndex: {
            get() {
                return this.$store.state.activityManagerViewIndex;
            },
            set(value) {
                this.$store.state.activityManagerViewIndex = value;
            }
        },
        forgeService: {
            get() {
                return this.$store.state.forgeService;
            }
        },
        viewer: {
            get() {
                return this.$store.state.viewer;
            }
        },
        isAMIS(){
            return this.$store.state.forgeSettings?.isAMIS && this.$store.getters['GET_ALL_AMIS_TAGS_IDS']?.length;
        },
        isDashboardFullScreen: {
            get(){
                return this.$store.getters['GET_IS_DASHBOARD_FULL_SCREEN'];
            },
            set(value){
                this.$store.commit('SET_IS_DASHBOARD_FULL_SCREEN', value);
            }
        },
        showInspectionDashboard: {
            get() {
                return this.$store.getters.GET_SHOW_INSPECTION_DASHBOARD;
            },
            set(value) {
                this.$store.commit('SET_SHOW_INSPECTION_DASHBOARD', value);
            }
        },
        showSisTestingDashboard: { 
            get() {
                return this.$store.getters.GET_SHOW_SIS_TESTING_DASHBOARD;
            },
            set(value) {
                this.$store.commit('SET_SHOW_SIS_TESTING_DASHBOARD', value);
            }
        },
        showWorkPackProgressDashboard: {
            get() {
                return this.$store.getters.GET_SHOW_WORK_PACK_PROGRESS_DASHBOARD;
            },
            set(value) {
                this.$store.commit('SET_SHOW_WORK_PACK_PROGRESS_DASHBOARD', value);
            }
        },
        isLeftMenuPinned: {
            get() {
                return this.$store.getters['GET_IS_LEFT_MENU_PINNED'];
            },
            set(value) {
                this.$store.commit('SET_IS_LEFT_MENU_PINNED', value);
            }
        },
    },
}
</script>

<style>
:root {
    /* root element */
    --primary-color: #ad5087;
    --light-primary-color: #e1c3d2;
    --light-primary-color2: #f9f1f6;
    --dark-primary-color: #78325c;

    /* Secondry colors */
    /* --secondry-color: #8ccecd;
    --light-secondry-color: #92bacc;
    --dark-secondry-color: #68bab9; */

    --secondry-color: #51A0C4;
    --light-secondry-color: #92bacc;
    --dark-secondry-color: #377896;

    --x-axis-color: #e62c2c;
    --y-axis-color: #0BB80B;
    --z-axis-color: #2C2CF1;

    --main-font: ArtifaktElement, Helvetica Neue, Segoe UI Semilight, sans-serif;
}

.viewers-2-compare-mode {
    position: absolute;
    width: 100% !important;
    height: 100%;
    top: 0;
    overflow: hidden;
}

.viewers-2-compare-mode.compare-right {
    right: 0;
}

.viewers-2-compare-mode:not(.compare-right) {
    left: 0;
}

.view-compare-mode {
    position: absolute !important;
    height: 100% !important;
    top: 0 !important;
}

.view-compare-mode.compare-right {
    right: 0;
}

.view-compare-mode:not(.compare-right) {
    left: 0;
}

.all-4-viewers-container {
    display: flex;
    flex-grow: 1;
    height: 100%;
    overflow: hidden;
    position: relative;
}

.all-2-viewers-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: calc(50% - 2px);
}

.left-info-container {
    height: 100%;
    display: flex;
    animation-name: left-menu-animation;
    animation-duration: .5s;
}

@keyframes left-menu-animation {
    from {
        width: 0;
    }

    to {
        width: auto;
    }
}

.views-options {
    color: white;
    background-color: var(--dark-primary-color);
    padding: 4px;
    height: 90px;
    position: absolute;
    width: 330px;
    left: calc(50% - 170px);
    top: calc(50% - 47px);
    z-index: 10;
    /* flex-flow: row-reverse; */
    border-radius: 5px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 15px;
}

.activity-views-options {
    width: 250px;
    color: white;
    background-color: var(--dark-primary-color);
    padding: 4px;
    height: 90px;
    position: absolute;
    left: 10px;
    top: 335px;
    z-index: 10;
    border-radius: 5px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 15px;
}

.view-options-cards {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
}

.viewer-options-names {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
}

.view-option-name {
    width: 40px;
    height: 40px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    color: var(--dark-primary-color);
    border-radius: 5px;
    font-style: italic;
}

.view-option-name:hover {
    background: var(--light-primary-color);
    color: white;
    cursor: pointer;
}

.view-option-icon {
    text-align: center;
    width: 70px;
    height: 70px;
    cursor: pointer;
    margin: 3px;
}

.view-option-icon:hover {
    color: lightgray;
}

/* grids */
.single-grid {
    background-size: cover;
    background-image: url(../images/grid1.png);
}

.single-grid:hover {
    background-image: url(../images/grid1-hover.png);
}

.double-grid {
    background-size: cover;
    background-image: url(../images/grid2.png);
}

.double-grid:hover {
    background-image: url(../images/grid2-hover.png);
}

.triple-grid {
    background-size: cover;
    background-image: url(../images/grid3.png);
}

.triple-grid:hover {
    background-image: url(../images/grid3-hover.png);
}

.horizontal-grid {
    height: 60px;
    background-position: center;
    background-size: cover;
    background-image: url(../images/grid5.png);
}

.horizontal-grid:hover {
    background-image: url(../images/grid5-hover.png);
}

.quad-grid,
.quad-grid-gray {
    background-size: cover;
    background-image: url(../images/grid4.png);
}

.quad-grid:hover {
    background-image: url(../images/grid4-hover.png);
}

.quad-grid-gray:hover {
    background-image: url(../images/grid4-hovergray.png);
}

.corner-close-btn {
    font-weight: 500;
    font-size: 12px;
    padding-top: 2px;
    font-family: cursive;
    background-color: #adadad;
    color: white;
    border-radius: 18pc;
    width: 22px;
    height: 20px;
    text-align: center;
    margin: 0px 15px;
    position: relative;
    cursor: pointer;
}

.corner-close-btn:hover {
    background-color: var(--dark-primary-color);
}

.top-title-bar {
    width: 100%;
    display: flex;
    height: 35px;
    justify-content: end;
    align-items: center;
    padding: 10px 0;
}

.top-title-name {
    flex-grow: 1;
    padding: 3px;
    text-align: center;
    font: bold 17px Helvetica, Arial, Sans-Serif;
}

.slash-btn {
    width: 18px;
    height: 23px;
    position: absolute;
    right: 3px;
    top: 3%;
    color: gray;
    background-color: black;
    border-radius: 0 18px 16px 0;
    cursor: pointer;
    padding: 5px 2px;
}

.left-panel {
    width: 300px;
    height: 100%;
    background-color: white;
    border: 1px solid gray;
    box-shadow: 1px 3px 10px 0 rgb(0 0 0 / 50%);
    display: flex;
    flex-direction: column;
    z-index: 8;
}

.pinned-panel {
    position: relative;
}

.not-pinned-panel {
    position: absolute;
    left: 46px;
    top: 8px;
    height: 90%;
    border-radius: 0 8px 8px 0;
    overflow: hidden;
}

.left-menu {
    position: relative;
    background-color: var(--light-primary-color2);
    width: 40px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 5px;
    border-right: 1px solid gray;
}

.canvas-dimension {
    position: absolute;
    z-index: 22;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
}

.notification-div {
    position: absolute;
    top: 10px;
    width: auto;
    height: 20px;
    background-color: lightgreen;
    font-family: var(--main-font);
    border: 1px solid green;
    text-align: center;
    padding: 5px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    animation-name: notification-animation;
    animation-duration: .5s;
    z-index: 9;
}

@keyframes notification-animation {
    from {
        height: 0;
        font-size: 0;
    }

    to {
        height: 20px;
        font-size: 16px;
    }
}

.viewers-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    position: absolute;
    justify-content: center;
}

#separator {
    /* cursor: col-resize; */
    background-color: lightgray;
    width: 3px;
    height: 100%;

    /* Prevent the browser's built-in drag from interfering */
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

#compare-separator {
    cursor: col-resize;
    background-color: lightgray;
    width: 5px;
    height: 100%;
    pointer-events: all;
    position: absolute;
    z-index: 7;

    /* Prevent the browser's built-in drag from interfering */
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.compare-separator-circle {
    cursor: col-resize;
    background-color: lightgray;
    width: 25px;
    height: 38px;
    pointer-events: all;
    top: 50%;
    margin-left: 2px;
    z-index: 7;
    user-select: none;
    border-bottom-right-radius: 22px;
    border-top-right-radius: 22px;
    border-top: 1px solid gray;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    padding-top: 18px;
    text-align: center;

    /* Prevent the browser's built-in drag from interfering */
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.compare-separator-circle:hover {
    background-color: var(--dark-primary-color);
}

#separator2,
#separator3 {
    /* cursor: row-resize; */
    background-color: lightgray;
    width: 100%;
    height: 3px;

    /* Prevent the browser's built-in drag from interfering */
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.right-btn {
    right: 5px;
}

.bottom-right {
    position: absolute;
    right: 65px;
    bottom: 5px;
    color: white;
    font-size: 16px;
    font-weight: inherit;
}

.left-label {
    left: 41px;
    border-radius: 0 4px 4px 0;
}

.rotate-all-2-viewers-container {
    display: flex;
    flex-direction: row !important;
    flex-grow: 1;
    width: 100% !important;
}

.rotate-all-2-viewers-container #separator2,
.rotate-all-2-viewers-container #separator3 {
    display: none
}

.rotate-all-2-viewers-container .page-view {
    height: 100% !important
}

.dashboard-space {
    width: calc(50vw - 20px);
    height: 100%;
    flex-shrink: 0;
    background-color: transparent;
    pointer-events: none;
}

.dashboard-space.full-screen-space {
    width: calc(100vw - 40px);
}

.empty-model .alert-box.error {
    display: none !important;
}
</style>
